import { canv } from '@/canv/global.js'
import { isBrowser } from '@/canv/utils.js'

export class textSelection {

    constructor(text) {
        this.text = text;
        this.reScheduleCursor();
    }

    draw() {

        var sortedSelection = this.getSortedSelection();

        for (var i = sortedSelection["selectionFirst"]["line"]; i <= sortedSelection["selectionLast"]["line"]; i++) {

            var selectionLine = this.text.lines[i];

            var selectionStartX = 0;
            var startIndex = 0;
            var endIndex = selectionLine.items.length;

            if (i == sortedSelection["selectionFirst"]["line"]) {
                startIndex = sortedSelection["selectionFirst"]["position"];
            }

            if (i == sortedSelection["selectionLast"]["line"]) {
                endIndex = sortedSelection["selectionLast"]["position"];
            }

            if (startIndex == 0) {
                selectionStartX = selectionLine.textStartX;
            } else if (selectionLine.items[startIndex - 1]) {
                selectionStartX = selectionLine.items[startIndex - 1].startX + selectionLine.items[startIndex - 1].getWidth();
            }

            var selectionWidth = selectionLine.getIntervalWidth(startIndex, endIndex - 1);

            if (this.isCursor()) {
                if (!this.showCursor) return;
                selectionWidth = canv.actionManager.getZoomConstant(2);

                canv.ctx.save();
                canv.ctx.fillStyle = "black";
                canv.ctx.fillRect(selectionStartX, selectionLine.startY, selectionWidth, -selectionLine.textHeight);
                canv.ctx.restore();
            } else if (startIndex == endIndex) {
                // мини выделение
                selectionWidth = canv.actionManager.getZoomConstant(10);

                canv.ctx.save();
                canv.ctx.fillStyle = "#0B99FF";
                canv.ctx.globalAlpha = 0.2;
                canv.ctx.lineWidth = 2 / canv.m[0];
                canv.ctx.fillRect(selectionStartX, selectionLine.startY, selectionWidth, -selectionLine.textHeight);
                canv.ctx.restore();
            } else {
                canv.ctx.save();
                canv.ctx.fillStyle = "#0B99FF";
                canv.ctx.globalAlpha = 0.2;
                canv.ctx.lineWidth = 2 / canv.m[0];
                canv.ctx.fillRect(selectionStartX, selectionLine.startY, selectionWidth, -selectionLine.textHeight);
                canv.ctx.restore();
            }

        }



    }



    // Important

    startSelection() {

        // Для resize и других действий, будучи в focused
        if (!this.text.isOver()) {
            return;
        }

        this.reScheduleCursor();

        if (!canv.keyboard.isShift()) {
            this.resetSelection();
            this.isSelectingProcess = true;
        }

        for (var i = 0; i < this.text.lines.length; i++) {
            var processingLine = this.text.lines[i];
            if (!processingLine.isOverLineBox()) {
                continue;
            }

            var position = this.simulateCursorPosition(processingLine);

            if (!canv.keyboard.isShift()) {
                this.setCursor(i, position);
            } else {
                this.setSelection(this.selectionStart["line"], this.selectionStart["position"], i, position);
            }
        }
        this.updateStyles();
    }

    updateSelection() {
        if (!this.isSelectingProcess) return;

        var pt = canv.actionManager.getActionPoint();

        for (var i = 0; i < this.text.lines.length; i++) {
            var currentLine = this.text.lines[i];

            // тут важно где стоят break
            // Так как мы идем сверху вниз по линиям, то в if где проверяется y > startY break не делаем, а ищем последнюю такую строку
            if (currentLine.lineIndex < this.selectionStart["line"]) {

                if (pt.y < currentLine.startY - currentLine.textHeight) {
                    this.selectionEnd["line"] = i;
                    this.selectionEnd["position"] = 0;
                    break;
                } else if (pt.y >= currentLine.startY - currentLine.textHeight && pt.y < currentLine.startY) {
                    var position = this.simulateCursorPosition(currentLine);
                    this.selectionEnd["line"] = i;
                    this.selectionEnd["position"] = position;
                    break;
                }

            } else if (currentLine.lineIndex == this.selectionStart["line"]) {

                if (pt.y < currentLine.startY - currentLine.textHeight) {
                    this.selectionEnd["line"] = i;
                    this.selectionEnd["position"] = 0;
                    break;
                } else if (pt.y >= currentLine.startY - currentLine.textHeight && pt.y < currentLine.startY) {
                    var position = this.simulateCursorPosition(currentLine);
                    this.selectionEnd["line"] = i;
                    this.selectionEnd["position"] = position;
                    break;
                } else {
                    this.selectionEnd["line"] = i;
                    this.selectionEnd["position"] = currentLine.items.length;
                }

            } else {
                if (pt.y > currentLine.startY) {
                    this.selectionEnd["line"] = i;
                    this.selectionEnd["position"] = currentLine.items.length;
                } else if (pt.y >= currentLine.startY - currentLine.textHeight && pt.y < currentLine.startY) {
                    var position = this.simulateCursorPosition(currentLine);
                    this.selectionEnd["line"] = i;
                    this.selectionEnd["position"] = position;
                    break;
                }

            }

        }

        this.updateStyles();

    }

    stopSelection() {
        this.isSelectingProcess = false;
    }

    removeSelection() {

        var sortedSelection = this.getSortedSelection();

        var lineIndex = sortedSelection["selectionFirst"]["line"];

        for (var i = sortedSelection["selectionFirst"]["line"]; i <= sortedSelection["selectionLast"]["line"]; i++) {

            var selectionLine = this.text.lines[lineIndex];

            var startIndex = 0;
            var endIndex = selectionLine.items.length;

            if (i == sortedSelection["selectionFirst"]["line"]) {
                startIndex = sortedSelection["selectionFirst"]["position"];
            }

            if (i == sortedSelection["selectionLast"]["line"]) {
                endIndex = sortedSelection["selectionLast"]["position"];
            }

            selectionLine.items.splice(startIndex, endIndex - startIndex);

            if (i != sortedSelection["selectionFirst"]["line"]) {
                for (var k = 0; k < selectionLine.items.length; k++) {
                    this.text.lines[lineIndex - 1].items.push(selectionLine.items[k]);
                }
                this.text.lines.splice(lineIndex, 1);
            } else {
                lineIndex++;
            }
        }

        this.selectionLeftSqueeze();
        // чтобы проставить правильный lineIndex
        this.text.updateDims();
    }



    // simulateCursorPosition

    simulateCursorPosition(line) {
        var pt = canv.actionManager.getActionPoint();

        var position = 0;

        if (line.items.length != 0 && pt.x > line.items[line.items.length - 1].startX + line.items[line.items.length - 1].getWidth()) {
            position = line.items.length;
        }

        for (var i = 0; i < line.items.length; i++) {
            if (pt.x >= line.items[i].startX && pt.x <= line.items[i].startX + line.items[i].getWidth()) {
                if (pt.x <= line.items[i].startX + line.items[i].getWidth() / 2) {
                    // тыкнули в левую часть буквы
                    position = i;
                } else {
                    // тыкнули в правую часть буквы
                    position = i + 1;
                }
                break;
            }
        }

        return position;
    }





    // Tools

    isCursor() {
        return this.selectionStart["line"] == this.selectionEnd["line"] && this.selectionStart["position"] == this.selectionEnd["position"];
    }

    getSortedSelection() {

        var selectionFirst = this.selectionStart;
        var selectionLast = this.selectionEnd;

        if (this.selectionStart["line"] == this.selectionEnd["line"]) {
            if (this.selectionStart["position"] > this.selectionEnd["position"]) {
                selectionFirst = this.selectionEnd;
                selectionLast = this.selectionStart;
            }
        } else if (this.selectionStart["line"] > this.selectionEnd["line"]) {
            selectionFirst = this.selectionEnd;
            selectionLast = this.selectionStart;
        }

        var result = {
            "selectionFirst": selectionFirst,
            "selectionLast": selectionLast
        };

        return result;
    }

    setCursor(lineIndex, positionIndex) {
        this.selectionStart["line"] = lineIndex;
        this.selectionStart["position"] = positionIndex;
        this.selectionEnd["line"] = lineIndex;
        this.selectionEnd["position"] = positionIndex;
        this.updateStyles(true);
    }

    resetSelection({ selectionStart, selectionEnd } = { selectionStart: { 'line': 0, 'position': 0 }, selectionEnd: { 'line': 0, 'position': 0 } }) {
        this.selectionStart = selectionStart;
        this.selectionEnd = selectionEnd;
    }

    getSelectionSequential() {

        // startLine нужен так как position одинаковый для конца i строки и начала i+1
        var result = {
            "start": -1,
            "startLine": -1,
            "end": -1,
            "endLine": -1
        };

        var symbolsCount = 0;

        for (var i = 0; i < this.text.lines.length; i++) {

            if (i == this.selectionStart["line"]) {
                result["start"] = symbolsCount + this.selectionStart["position"];
                result["startLine"] = i;
            }

            if (i == this.selectionEnd["line"]) {
                result["end"] = symbolsCount + this.selectionEnd["position"];
                result["endLine"] = i;
            }

            symbolsCount += this.text.lines[i].items.length;

        }

        return result;
    }

    loadSelectionSequential(data) {
        var symbolsCount = 0;

        var startPriority = false;
        var endPriority = false;

        for (var i = 0; i < this.text.lines.length; i++) {

            if (data["start"] >= symbolsCount && data["start"] <= symbolsCount + this.text.lines[i].items.length) {
                if (!startPriority) {
                    this.selectionStart["line"] = i;
                    this.selectionStart["position"] = data["start"] - symbolsCount;
                    if (i == data["startLine"]) {
                        startPriority = true;
                    }
                }
            }

            if (data["end"] >= symbolsCount && data["end"] <= symbolsCount + this.text.lines[i].items.length) {
                if (!endPriority) {
                    this.selectionEnd["line"] = i;
                    this.selectionEnd["position"] = data["end"] - symbolsCount;
                    if (i == data["endLine"]) {
                        endPriority = true;
                    }
                }
            }

            symbolsCount += this.text.lines[i].items.length;
        }

        // тут не вызываем this.updateStyles() так как иначе FitShape->... вызывает тяжелый widgetMenu.reopen
        // loadSelectionSequential используется, чтобы сохранить позицию курсора, а значит стили можно не обновлять

    }




    // word selecting --------------------------------------------------------------------------

    wordSelect() {

        if (!this.text.isOver()) {
            return;
        }


        for (var i = 0; i < this.text.lines.length; i++) {
            var processingLine = this.text.lines[i];

            if (!processingLine.isOverLineBox() || processingLine.items.length === 0) continue;

            const aroundSymbolIndex = this.wordSelectSymbolAroundLine(processingLine);

            this.wordSelectApply(i, aroundSymbolIndex);

            break;
        }

        this.updateStyles();
    }

    lineSelect() {
        if (!this.text.isOver()) {
            return;
        }

        for (let i = 0; i < this.text.lines.length; i++) {
            const processingLine = this.text.lines[i];
            if (!processingLine.isOverLineBox() || processingLine.items.length === 0) continue;
            this.setSelection(i, 0, i, processingLine.items.length);
            break;
        }
    }

    wordSelectSymbolAroundLine(line) {
        var pt = canv.actionManager.getActionPoint();

        if (line.items.length != 0 && pt.x > line.items[line.items.length - 1].startX + line.items[line.items.length - 1].getWidth()) {
            return line.items.length - 1;
        }

        for (var i = 0; i < line.items.length; i++) {
            if (pt.x >= line.items[i].startX && pt.x <= line.items[i].startX + line.items[i].getWidth()) {
                return i;
            }
        }

        return 0;
    }

    wordSelectApply(aroundSymbolLineIndex, aroundSymbolIndex) {

        const isSymbolMode = this.text.lines[aroundSymbolLineIndex].items[aroundSymbolIndex].symbol != " ";

        let predicat = (item) => item.symbol != " "

        if (!isSymbolMode) {
            predicat = (item) => item.symbol == " "
        }

        const result = this.findWord(aroundSymbolLineIndex, aroundSymbolIndex, predicat);

        this.setSelection(result["start"]["line"], result["start"]["position"], result["end"]["line"], result["end"]["position"]);
    }

    // ------------------------------------------------------------------------------------------------------------------------


    // word tools ---------------------------------------------------------------------------------

    findWord(symbolLine, symbolPosition, predicat, enterStop = true) {
        const wordStartData = {
            "line": symbolLine,
            "position": symbolPosition,
        };

        const wordEndData = {
            "line": symbolLine,
            "position": symbolPosition,
        };

        this.findWordBegin(symbolLine, symbolPosition, wordStartData, predicat, enterStop);
        this.findWordEnd(symbolLine, symbolPosition, wordEndData, predicat, enterStop);

        return {
            "start": wordStartData,
            "end": wordEndData
        }
    }

    findWordBegin(aroundSymbolLineIndex, aroundSymbolIndex, wordSelectDataStart, predicat, enterStop = true) {
        // ищем начало слова
        for (let i = aroundSymbolLineIndex; i >= 0; i--) {
            const currentLine = this.text.lines[i];

            if (enterStop && i != aroundSymbolLineIndex && currentLine.enterExists) {
                // если вы перешли на линию, на которой есть enter, то останавливаемся
                break;
            }

            let startSymbolIndex = currentLine.items.length - 1;
            if (i == aroundSymbolLineIndex) {
                startSymbolIndex = aroundSymbolIndex;
            }

            for (let k = startSymbolIndex; k >= 0; k--) {
                if (predicat(currentLine.items[k])) {
                    wordSelectDataStart["line"] = i;
                    wordSelectDataStart["position"] = k;
                } else {
                    return;
                }
            }
        }
    }

    findWordEnd(aroundSymbolLineIndex, aroundSymbolIndex, wordSelectDataEnd, predicat, enterStop = true) {
        // ищем начало слова
        for (let i = aroundSymbolLineIndex; i < this.text.lines.length; i++) {
            const currentLine = this.text.lines[i];

            if (enterStop && i != aroundSymbolLineIndex && this.text.lines[i - 1].enterExists) {
                // тут this.text.lines[i - 1] всегда существует, потому что i != aroundSymbolLineIndex
                // если вы перешли на линию, на которой есть enter, то останавливаемся
                break;
            }

            let startSymbolIndex = 0;
            if (i == aroundSymbolLineIndex) {
                startSymbolIndex = aroundSymbolIndex;
            }

            for (let k = startSymbolIndex; k < currentLine.items.length; k++) {
                if (predicat(currentLine.items[k])) {
                    wordSelectDataEnd["line"] = i;
                    wordSelectDataEnd["position"] = k + 1;
                } else {
                    return;
                }
            }
        }
    }

    // --------------------------------------------------------------------------------------------




    // Squeeze + move -----------------------------------

    selectionLeftSqueeze() {
        this.reScheduleCursor();
        var sortedSelection = this.getSortedSelection();
        this.selectionEnd["line"] = sortedSelection["selectionFirst"]["line"];
        this.selectionEnd["position"] = sortedSelection["selectionFirst"]["position"];
        this.selectionStart["line"] = sortedSelection["selectionFirst"]["line"];
        this.selectionStart["position"] = sortedSelection["selectionFirst"]["position"];
        // тут не надо вызывать this.updateStyles(), так как иначе если выставить настройку в меню, а потом ввести символ
        // сначала вызывется removoeSelection->selectionLeftSqueeze, который выставит this.text.fontSize в значение в зависимости от курсора, то-есть мы потеряем значение,
        // которое только что выставили в меню
        // в removeSelection также вызывается moveCursor, вот там уже нужен updateStyles
        // Смысл: selectionLeftSqueeze не меняет selectionStart, а значит не меняет стили в зависимости от положения курсора
    }

    selectionRightSqueeze() {
        this.reScheduleCursor();
        var sortedSelection = this.getSortedSelection();
        this.selectionEnd["line"] = sortedSelection["selectionLast"]["line"];
        this.selectionEnd["position"] = sortedSelection["selectionLast"]["position"];
        this.selectionStart["line"] = sortedSelection["selectionLast"]["line"];
        this.selectionStart["position"] = sortedSelection["selectionLast"]["position"];
    }

    moveCursorLeft(selectionMode = false) {
        // если selectionMode = false, то у нас должен быть курсор, так как мы двигаем selectionStart, без проверки
        // selectionMode true вызывается только из processArrowShift
        if (this.selectionEnd["position"] == 0) {
            if (this.selectionEnd["line"] != 0) {
                if (!selectionMode) {
                    this.setCursor(this.selectionEnd["line"] - 1, this.text.lines[this.selectionEnd["line"] - 1].items.length);
                } else {
                    this.setSelection(this.selectionStart["line"], this.selectionStart["position"], this.selectionEnd["line"] - 1, this.text.lines[this.selectionEnd["line"] - 1].items.length);
                }
            }
        } else {
            if (!selectionMode) {
                this.selectionStart["position"]--;
                this.selectionEnd["position"]--;
            } else {
                this.selectionEnd["position"]--;
            }
        }
        this.updateStyles(true);
    }

    moveCursorPositionRight(selectionMode = false) {
        if (this.selectionEnd["position"] == this.text.lines[this.selectionEnd["line"]].items.length) {
            if (this.selectionEnd["line"] != this.text.lines.length - 1) {
                if (!selectionMode) {
                    this.setCursor(this.selectionEnd["line"] + 1, 0);
                } else {
                    this.setSelection(this.selectionStart["line"], this.selectionStart["position"], this.selectionEnd["line"] + 1, 0);
                }
            }
        } else {
            if (!selectionMode) {
                this.selectionStart["position"]++;
                this.selectionEnd["position"]++;
            } else {
                this.selectionEnd["position"]++;
            }
        }
    }

    moveCursorRight(selectionMode = false) {
        this.moveCursorPositionRight(selectionMode);
        this.updateStyles(true);
    }

    moveCursorUp(selectionMode = false) {
        if (this.selectionEnd["line"] == 0) return;

        if (this.text.lines[this.selectionEnd["line"] - 1].items.length < this.selectionEnd["position"]) {
            if (!selectionMode) {
                this.setCursor(this.selectionEnd["line"] - 1, this.text.lines[this.selectionEnd["line"] - 1].items.length);
            } else {
                this.setSelection(this.selectionStart["line"], this.selectionStart["position"], this.selectionEnd["line"] - 1, this.text.lines[this.selectionEnd["line"] - 1].items.length);
            }
        } else {
            if (!selectionMode) {
                this.setCursor(this.selectionEnd["line"] - 1, this.selectionEnd["position"]);
            } else {
                this.setSelection(this.selectionStart["line"], this.selectionStart["position"], this.selectionEnd["line"] - 1, this.selectionEnd["position"]);
            }
        }
        this.updateStyles(true);
    }

    moveCursorDown(selectionMode = false) {
        if (this.selectionEnd["line"] == this.text.lines.length - 1) return;

        if (this.text.lines[this.selectionEnd["line"] + 1].items.length < this.selectionEnd["position"]) {
            if (!selectionMode) {
                this.setCursor(this.selectionEnd["line"] + 1, this.text.lines[this.selectionEnd["line"] + 1].items.length);
            } else {
                this.setSelection(this.selectionStart["line"], this.selectionStart["position"], this.selectionEnd["line"] + 1, this.text.lines[this.selectionEnd["line"] + 1].items.length);
            }
        } else {
            if (!selectionMode) {
                this.setCursor(this.selectionEnd["line"] + 1, this.selectionEnd["position"]);
            } else {
                this.setSelection(this.selectionStart["line"], this.selectionStart["position"], this.selectionEnd["line"] + 1, this.selectionEnd["position"]);
            }
        }
        this.updateStyles(true);
    }

    selectAll() {
        this.selectionStart["line"] = 0;
        this.selectionStart["position"] = 0;
        this.selectionEnd["line"] = this.text.lines.length - 1;
        this.selectionEnd["position"] = this.text.lines[this.text.lines.length - 1].items.length;
        this.updateStyles(); // не сработает, потому что leftSymbol и rightSymbol будут null
    }

    setSelection(startLine, startPosition, endLine, endPosition) {
        this.selectionStart["line"] = startLine;
        this.selectionStart["position"] = startPosition;
        this.selectionEnd["line"] = endLine;
        this.selectionEnd["position"] = endPosition;
        this.updateStyles(true);
    }

    selectToLineStart() {
        const anchor = this.selectionStart;
        const head = this.selectionEnd;

        this.setSelection(anchor.line, anchor.position, head.line, 0);
    }


    selectToLineEnd() {
        const anchor = this.selectionStart;
        const head = this.selectionEnd;

        const lineLength = this.text.lines[head.line].items.length;
        this.setSelection(anchor.line, anchor.position, head.line, lineLength);
    }



    // update font style ------------------------------------------

    updateStyles(checkMenuUpdate = false) {
        const previousColor = this.lastTextColor;

        // ищем символ левее курсора/выделения
        const leftSymbol = this.getUpdateStylesLeftSymbol();

        // ищем символ правее курсора/выделения
        const rightSymbol = this.getUpdateStylesRightSymbol();

        if (leftSymbol != null) {
            this.updateStylesSymbol(leftSymbol);
        } else if (rightSymbol != null) {
            this.updateStylesSymbol(rightSymbol);
        }

        const sortedSelection = this.getSortedSelection();

        if (sortedSelection["selectionFirst"]["line"] > 0 && sortedSelection["selectionFirst"]["line"] < this.text.lines.length) {
            const currentLine = this.text.lines[sortedSelection["selectionFirst"]["line"]];
            this.text.bullettedList = currentLine.bullettedList;
            this.text.align = currentLine.alignment;
        }

        if (this.text.isFocused && checkMenuUpdate) {
            if (!previousColor) {
                this.lastTextColor = this.text.fontColor;
                return;
            }

            const nextColor = this.text.fontColor;

            if (previousColor !== nextColor) {
                this.lastTextColor = nextColor;
                canv.widgetMenu.reopen();
            }
        }
    }

    getUpdateStylesLeftSymbol() {

        const sortedSelection = this.getSortedSelection();

        if (sortedSelection["selectionFirst"]["position"] > 0) {
            return this.text.lines[sortedSelection["selectionFirst"]["line"]].items[sortedSelection["selectionFirst"]["position"] - 1];
        }

        for (let i = sortedSelection["selectionFirst"]["line"] - 1; i >= 0; i--) {
            const currentLine = this.text.lines[i];
            if (currentLine.items.length != 0) {
                return currentLine.items[currentLine.items.length - 1];
            }
        }

        return null;
    }

    getUpdateStylesRightSymbol() {

        const sortedSelection = this.getSortedSelection();

        if (sortedSelection["selectionFirst"]["position"] <= this.text.lines[sortedSelection["selectionFirst"]["line"]].items.length - 1) {
            return this.text.lines[sortedSelection["selectionFirst"]["line"]].items[sortedSelection["selectionFirst"]["position"]];
        }

        for (let i = sortedSelection["selectionFirst"]["line"] + 1; i < this.text.lines.length; i++) {
            const currentLine = this.text.lines[i];
            if (currentLine.items.length != 0) {
                return currentLine.items[0];
            }
        }

        return null;
    }

    updateStylesSymbol(symbol) {
        this.text.fontSize = symbol.fontSize;
        this.text.fontStyle = symbol.fontStyle;
        this.text.fontColor = symbol.fontColor;
        this.text.fontBold = symbol.fontBold;
        this.text.fontStrike = symbol.isStriked;
        this.text.backgroundColor = symbol.backgroundColor;


        const sortedSelection = this.getSortedSelection();
        let calculatedLink = "";

        // в этой функции мы считаем настройки для будущих симовлов. Для link логика чуть сложнее.
        // не берем link просто из symbol, иначе если текст только ссылка - нельзя продожить писать не ссылку (можно, но очень не удобно)
        // тут обязательна проверка на isFocused. Так как эта функцию вызывается из loadState, то-есть может вызывать без interaction и, соответственно без selection
        if (this.text.isFocused && sortedSelection["selectionFirst"]["position"] > 0 && sortedSelection["selectionFirst"]["position"] <= this.text.lines[sortedSelection["selectionFirst"]["line"]].items.length - 1) {
            const linkBeforeCursor = this.text.lines[sortedSelection["selectionFirst"]["line"]].items[sortedSelection["selectionFirst"]["position"] - 1].link;
            const linkAfterCursor = this.text.lines[sortedSelection["selectionFirst"]["line"]].items[sortedSelection["selectionFirst"]["position"]].link;
            if (linkBeforeCursor == linkAfterCursor) {
                calculatedLink = linkBeforeCursor;
            }
        }

        this.text.symbolLink = calculatedLink;
    }

    // ------------------------------------------------------------




    // Cursor timer

    toggleCursor() {
        this.showCursor = !this.showCursor;
        canv.redraw();
    }

    reScheduleCursor() {
        if (!isBrowser()) return;
        clearInterval(this.cursorTimer);
        this.showCursor = true;
        this.cursorTimer = setInterval(this.toggleCursor.bind(this), 700);
    }

    offCursor() {
        clearInterval(this.cursorTimer);
        this.showCursor = false;
    }




    text = null;
    isSelectingProcess = false;
    cursorTimer = null;
    showCursor = false;
    lastTextColor = null;


    selectionStart = {
        "line": 0,
        "position": 0,
    };

    selectionEnd = {
        "line": 0,
        "position": 0,
    };

}
